export default function toLength(value, length = 15) {
    if (value) {
        if (value.length >= length) {
            return value.substring(0, length) + "...";
        }
            return value;

    }
}
